import { render, staticRenderFns } from "./ManifestViewModal.vue?vue&type=template&id=2684689e"
import script from "./ManifestViewModal.vue?vue&type=script&lang=ts"
export * from "./ManifestViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports